import template from './radioitem.html'
import ko from 'knockout'
const FIELDIDAFFIX = '_radio'
function init (params) {
  this.value = params.value
  this.currentValue = params.currentValue
  this.radioname = params.radioname
  this.fieldid = params.fieldid + params.value.value + FIELDIDAFFIX
  this.disabled = this.value.disabled
  this.checked = ko.computed(() => {
    // todo 默认是value/label 后续要改成其他自定义格式
    return this.currentValue() === this.value.value
  })
  this.change = (data) => {
    this.currentValue(this.value.value)
    params.onChange && params.onChange(this.value.value)
  }
}
export default {
  name: 'radio-item',
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/radio/radioitem.js